import { useEffect, useState } from "react";

/** Format the time remaining until an ISO timestamp as e.g. "6j 3h" / "5h 12min". */
export function formatRemaining(untilIso, t) {
  if (!untilIso) return "";
  const ms = new Date(untilIso).getTime() - Date.now();
  if (ms <= 0) return t("cd.expired");
  const totalMin = Math.floor(ms / 60000);
  const d = Math.floor(totalMin / 1440);
  const h = Math.floor((totalMin % 1440) / 60);
  const m = totalMin % 60;
  if (d > 0) return `${d}${t("cd.d")} ${h}${t("cd.h")}`;
  if (h > 0) return `${h}${t("cd.h")} ${m}${t("cd.m")}`;
  return `${m}${t("cd.m")}`;
}

/** Re-render every `intervalMs` so countdowns tick live. */
export function useTicker(intervalMs = 60000) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((x) => x + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}

/** True while a boost is active but expires within `hours` (default 48h). */
export function isExpiringSoon(untilIso, hours = 48) {
  if (!untilIso) return false;
  const ms = new Date(untilIso).getTime() - Date.now();
  return ms > 0 && ms <= hours * 3600000;
}

/** True when a boost expired within the last `hours` (win-back window, default 24h). */
export function isRecentlyExpired(untilIso, hours = 24) {
  if (!untilIso) return false;
  const ms = Date.now() - new Date(untilIso).getTime();
  return ms > 0 && ms <= hours * 3600000;
}
